import { ReactNode, FC } from "react";
import { AuthUserProvider } from "@/providers/AuthUser";
import { SettingProvider } from "@/context";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "@/components/hoc/SnackbarAlert";
import SnackbarCloseButton from "@/components/atoms/Snackbar/SnackbarCloseButton";

type Props = {
  children: ReactNode;
};
export const Providers: FC<Props> = (props) => {
  return (
    <>
      <SettingProvider>
        <AuthUserProvider>
          <SnackbarProvider
            autoHideDuration={null}
            maxSnack={20}
            action={(snackbarKey) => (
              <SnackbarCloseButton snackbarKey={snackbarKey} />
            )}
            hideIconVariant
          >
            <SnackbarUtilsConfigurator />
            {props.children}
          </SnackbarProvider>
        </AuthUserProvider>
      </SettingProvider>
    </>
  );
};
